export default {"src":"/_next/static/media/webflow.64a4e6a8.svg","height":60,"width":238,"blurWidth":0,"blurHeight":0};